import { api, setAccessToken } from "./api";

/**
 * Super-admin auth — backed by the NestJS `mindtalk-doctors-backend`.
 *
 *   POST /auth/admin/login   { username, password } → { accessToken, expiresIn }
 *   POST /auth/logout        revokes the refresh cookie
 *
 * The backend mints a JWT with role=ADMIN; we store the access token in localStorage and
 * the refresh token rides along in an HttpOnly cookie. The same token authorises every
 * `/:campus/...` route, so admins can switch campuses without re-authenticating.
 */

export async function loginAdmin({ username, password }) {
  const { data } = await api.post(`/auth/admin/login`, { username, password });
  if (data?.accessToken) setAccessToken(data.accessToken);
  return data;
}

export async function logoutAdmin() {
  // Empty string keeps class-validator happy; the backend reads the real refresh token
  // from the HttpOnly cookie. Local state is wiped regardless of whether the call succeeds.
  try {
    await api.post(`/auth/logout`, { refreshToken: "" });
  } catch (err) {
    console.warn("[auth] logout request failed, clearing local state anyway", err);
  } finally {
    setAccessToken(null);
    localStorage.removeItem("uda2.user");
  }
}
